
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/lists/list",
      function () {
        return require("private-next-pages/user/lists/list/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/lists/list"])
      });
    }
  